import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {LeadModalStep} from "../../../application/types/LeadModalStep";
import {RecommendedPropertyApplicationsType} from "../../../application/types/recommended_property_applications_type";
import {ApplicationSource, ApplicationSourceSection} from "../../../application/utils/ApplicationSource";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";
import {IMultileadState} from "../types/IMultileadState";

const initialState: IMultileadState = {
    isModalOpen: false,
    mainPropertyId: null,
    mainOfferId: null,
    mainVendorId: null,
    source: null,
    sourceSection: null,
    presentStep: LeadModalStep.MULTILEAD,
    selectedProperties: [],
    priceRange: {
        min: null,
        max: null
    },
    applicationPayload: [],
    allPropertiesCount: 0
};

export const multileadSlice = createSlice({
    name: "multilead",
    initialState,
    reducers: {
        openMultilead: (
            state,
            action: PayloadAction<{
                mainPropertyId: number;
                mainOfferId: number;
                mainVendorId: number;
                source: ApplicationSource;
                sourceSection: ApplicationSourceSection;
            }>
        ) => {
            state.isModalOpen = true;
            state.mainPropertyId = action.payload.mainPropertyId;
            state.mainOfferId = action.payload.mainOfferId;
            state.mainVendorId = action.payload.mainVendorId;
            state.source = action.payload.source;
            state.sourceSection = action.payload.sourceSection;
        },
        closeMultilead: (state) => {
            state.isModalOpen = initialState.isModalOpen;
        },
        setMultileadStep: (state, action: PayloadAction<{step: LeadModalStep}>) => {
            state.presentStep = action.payload.step;
        },
        setSelectedMultileadProperties: (state, action: PayloadAction<{selectedProperties: IRecommendedProperty[]}>) => {
            state.selectedProperties = action.payload.selectedProperties;
        },
        resetMultileadState: () => initialState,
        setPriceRangeMultilead: (state, action: PayloadAction<{minPrice: number | null; maxPrice: number | null}>) => {
            state.priceRange.min = action.payload.minPrice;
            state.priceRange.max = action.payload.maxPrice;
        },
        setApplicationPayload: (state, action: PayloadAction<{applicationPayload: RecommendedPropertyApplicationsType[]}>) => {
            state.applicationPayload = action.payload.applicationPayload;
        },
        setAllPropertiesCount: (state, action: PayloadAction<{count: number}>) => {
            state.allPropertiesCount = action.payload.count;
        }
    }
});

export const {
    openMultilead,
    closeMultilead,
    setMultileadStep,
    setSelectedMultileadProperties,
    resetMultileadState,
    setPriceRangeMultilead,
    setApplicationPayload,
    setAllPropertiesCount
} = multileadSlice.actions;
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {LeadModalStep} from "../../../application/types/LeadModalStep";
import {RecommendedPropertyApplicationsType} from "../../../application/types/recommended_property_applications_type";
import {ApplicationSource, ApplicationSourceSection} from "../../../application/utils/ApplicationSource";
import {IRecommendedProperty} from "../../../property/types/IRecommendedProperty";
import {IMultileadState} from "../types/IMultileadState";

const initialState: IMultileadState = {
    isModalOpen: false,
    mainPropertyId: null,
    mainOfferId: null,
    mainVendorId: null,
    source: null,
    sourceSection: null,
    presentStep: LeadModalStep.MULTILEAD,
    selectedProperties: [],
    priceRange: {
        min: null,
        max: null
    },
    applicationPayload: [],
    allPropertiesCount: 0
};

export const multileadSlice = createSlice({
    name: "multilead",
    initialState,
    reducers: {
        openMultilead: (
            state,
            action: PayloadAction<{
                mainPropertyId: number;
                mainOfferId: number;
                mainVendorId: number;
                source: ApplicationSource;
                sourceSection: ApplicationSourceSection;
            }>
        ) => {
            state.isModalOpen = true;
            state.mainPropertyId = action.payload.mainPropertyId;
            state.mainOfferId = action.payload.mainOfferId;
            state.mainVendorId = action.payload.mainVendorId;
            state.source = action.payload.source;
            state.sourceSection = action.payload.sourceSection;
        },
        closeMultilead: (state) => {
            state.isModalOpen = initialState.isModalOpen;
        },
        setMultileadStep: (state, action: PayloadAction<{step: LeadModalStep}>) => {
            state.presentStep = action.payload.step;
        },
        setSelectedMultileadProperties: (state, action: PayloadAction<{selectedProperties: IRecommendedProperty[]}>) => {
            state.selectedProperties = action.payload.selectedProperties;
        },
        resetMultileadState: () => initialState,
        setPriceRangeMultilead: (state, action: PayloadAction<{minPrice: number | null; maxPrice: number | null}>) => {
            state.priceRange.min = action.payload.minPrice;
            state.priceRange.max = action.payload.maxPrice;
        },
        setApplicationPayload: (state, action: PayloadAction<{applicationPayload: RecommendedPropertyApplicationsType[]}>) => {
            state.applicationPayload = action.payload.applicationPayload;
        },
        setAllPropertiesCount: (state, action: PayloadAction<{count: number}>) => {
            state.allPropertiesCount = action.payload.count;
        }
    }
});

export const {
    openMultilead,
    closeMultilead,
    setMultileadStep,
    setSelectedMultileadProperties,
    resetMultileadState,
    setPriceRangeMultilead,
    setApplicationPayload,
    setAllPropertiesCount
} = multileadSlice.actions;
